<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="伙伴名称：">
                    <el-input size="small" v-model.trim="formInline.company" maxlength="60" clearable 
                        placeholder="请输入伙伴名称" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="伙伴Id：">
                    <el-input size="small" v-model.trim="formInline.agent_id" maxlength="60" clearable 
                        placeholder="请输入伙伴Id" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="Payers：" v-if="curRole!='sales'">
                    <el-select size="small" v-model="formInline.payers" clearable filterable 
                        @change="search" placeholder="请选择" style="width:180px">
                        <el-option
                            v-for="(item,index) in payersList"
                            :key="index"
                            :label="item.name+'('+item.payer_id+')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售：" v-if="curRole!='sales'">
                    <el-select size="small" v-model="formInline.sales" clearable filterable 
                        @change="search" placeholder="请选择" style="width:120px">
                        <el-option
                            v-for="(item,index) in salesList"
                            :key="index"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="search" type="primary" icon="Search" 
                        v-show="isShowBtn('agentManage','伙伴管理','Search')">查询</el-button>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="reset" icon="Refresh">重置</el-button>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="add" type="success" icon="Plus" 
                        v-show="isShowBtn('agentManage','伙伴管理','Create')">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" 
                v-loading="loadingPage" style="width:100%" :key="payersList.length">
                <el-table-column type="index" width="70" align="center" label="序号">
                        <template #default="scope">
                            <span>{{ getIndex(scope.$index) }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column min-width="110" prop="company" label="伙伴名称" :show-overflow-tooltip="true">
                        <template #default="scope">
                            {{ scope.row.company }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column width="110" prop="agent_id" label="伙伴Id">
                        <template #default="scope">
                            {{ scope.row.agent_id }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column min-width="110" prop="payers" label="Payers" :show-overflow-tooltip="true">
                        <template #default="scope">
                            {{ getPayerNames(scope.row.payers) }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column width="110" prop="sales" label="销售">
                        <template #default="scope">
                            {{ scope.row.sales }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column min-width="100" prop="email" label="邮箱">
                        <template #default="scope">
                            {{ scope.row.email }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column min-width="100" prop="address" label="地址" :show-overflow-tooltip="true">
                        <template #default="scope">
                            {{ scope.row.address }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column width="120" prop="tel" label="电话">
                        <template #default="scope">
                            {{ scope.row.tel }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="操作" align="center" fixed="right" width="270">
                        <template #default="scope">
                            <div class="action-buttons">
                                <el-button size="small" type="warning" @click="manageApiKey(scope.row)" icon="Key"
                                    v-if="curRole === 'admin'">
                                    API Key
                                </el-button>
                                <el-button size="small" type="primary" @click="edit(scope.row)" icon="Edit" 
                                    v-show="isShowBtn('agentManage','伙伴管理','Update')">
                                    编辑
                                </el-button>
                                <el-button size="small" type="danger" @click="remove(scope.row.id)" icon="Delete" 
                                    v-show="isShowBtn('agentManage','伙伴管理','Delete')">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- Edit Dialog -->
        <el-dialog 
            v-model="dialogVisible" 
            :close-on-click-modal="false" 
            :before-close="cancel"
            width="600px"
            class="edit-dialog">
            
            <template #header>
                <div class="dialog-header">
                    <h3 class="dialog-title">
                        <el-icon>{{ isEdit ? 'Edit' : 'Plus' }}</el-icon>
                        {{ loadingTitle }}
                    </h3>
                </div>
            </template>

            <div class="dialog-content">
                <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" 
                    label-position="right" label-width="120px" class="edit-form">
                    <div class="form-section">
                        <el-form-item label="伙伴名称" prop="company">
                            <el-input v-model="formData.company" placeholder="请输入伙伴名称"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="伙伴Id" prop="agent_id">
                            <el-input v-model="formData.agent_id" placeholder="请输入伙伴Id"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="Payers" prop="payers">
                            <el-select v-model="formData.payers" :no-data-text="'暂无可分配Payer'" multiple filterable 
                                class="full-width" placeholder="请选择">
                                <el-option
                                    v-for="(item,index) in payerList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.payer_id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item label="销售" prop="sales">
                            <el-select v-model="formData.sales" v-if="curRole!='sales'" filterable 
                                class="full-width" placeholder="请选择">
                                <el-option
                                    v-for="(item,index) in salesList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.name"
                                ></el-option>
                            </el-select>
                            <el-input v-else v-model="formData.sales" disabled></el-input>
                        </el-form-item>
                        
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="formData.email" placeholder="可输入多个邮箱地址，逗号分割"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="电话" prop="tel">
                            <el-input v-model="formData.tel" placeholder="请输入电话号码"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="地址" prop="address">
                            <el-input v-model="formData.address" placeholder="请输入地址"></el-input>
                        </el-form-item>
                        
                        <el-divider content-position="left">多抬头出账</el-divider>
                        <el-form-item label="启用多抬头">
                            <el-switch v-model="formData.multi_header" :active-value="1" :inactive-value="0"></el-switch>
                        </el-form-item>
                        <template v-if="formData.multi_header == 1">
                            <el-form-item label="境内伙伴名称">
                                <el-input v-model="formData.company_cn" placeholder="境内账单显示的伙伴名称"></el-input>
                            </el-form-item>
                            <el-form-item label="境内账单地址">
                                <el-input v-model="formData.address_cn" placeholder="境内账单显示的地址"></el-input>
                            </el-form-item>
                            <el-form-item label="境外伙伴名称">
                                <el-input v-model="formData.company_global" placeholder="境外账单显示的伙伴名称"></el-input>
                            </el-form-item>
                            <el-form-item label="境外账单地址">
                                <el-input v-model="formData.address_global" placeholder="境外账单显示的地址"></el-input>
                            </el-form-item>
                        </template>
                    </div>
                </el-form>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <div class="footer-actions">
                        <el-button @click="cancel()" size="large">取消</el-button>
                        <el-button type="primary" @click="isEdit ? editSubmit(formData.id) : submitData()" size="large">
                            确定
                        </el-button>
                    </div>
                </div>
            </template>
        </el-dialog>

        <el-dialog
            v-model="apiKeyDialogVisible"
            title="CUR API Key"
            width="560px"
            :close-on-click-modal="false"
            @closed="clearApiKeyDialog">
            <div v-loading="apiKeyLoading">
                <el-descriptions :column="1" border>
                    <el-descriptions-item label="伙伴名称">{{ apiKeyAgent.company }}</el-descriptions-item>
                    <el-descriptions-item label="伙伴 ID">{{ apiKeyAgent.agent_id }}</el-descriptions-item>
                    <template v-if="apiKeyStatus.exists">
                        <el-descriptions-item label="Key 前缀">vstecs_cur_{{ apiKeyStatus.key.key_prefix }}.********</el-descriptions-item>
                        <el-descriptions-item label="创建时间">{{ apiKeyStatus.key.created_at || '-' }}</el-descriptions-item>
                        <el-descriptions-item label="最后使用">{{ apiKeyStatus.key.last_used_at || '尚未使用' }}</el-descriptions-item>
                    </template>
                    <el-descriptions-item v-else label="状态">未创建</el-descriptions-item>
                </el-descriptions>

                <div v-if="createdApiKey" class="api-key-result">
                    <el-alert
                        title="完整 API Key 仅显示本次，请立即复制并安全交付给伙伴。"
                        type="warning"
                        :closable="false"
                        show-icon />
                    <el-input v-model="createdApiKey" readonly type="textarea" :rows="3" />
                    <el-button type="primary" icon="CopyDocument" @click="copyApiKey">复制 API Key</el-button>
                </div>
            </div>

            <template #footer>
                <el-button @click="apiKeyDialogVisible = false">关闭</el-button>
                <el-button
                    v-if="!apiKeyStatus.exists"
                    type="primary"
                    icon="Key"
                    :loading="apiKeyLoading"
                    @click="createApiKey">
                    一键创建
                </el-button>
                <el-button
                    v-else
                    type="danger"
                    icon="Delete"
                    :loading="apiKeyLoading"
                    @click="deleteApiKey">
                    删除 API Key
                </el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from "@/components/Pagination";
    import {getAgentList,newAgent,deleterAgent,editAgent,getAgentApiKey,createAgentApiKey,deleteAgentApiKey,getUnassignedPayerList,getSalesList,getPayerList} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    export default {
        components:{
            Pagination
        },
        name:'agentManage',
        data() {
            const checkEmail = (rule, value, callback) => {
                if (value) {
                    var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+)$/
                    var num =0;
                    value=value.replaceAll('，',',');
                    value.split(',').forEach(el=>{
                        if(reg.test(el)==false){
                            num++;
                        }
                    })
                    if(num>0){
                        callback(new Error('邮箱格式错误'))
                    }else{
                        callback()
                    }
                } else {
                    callback()
                }
            }
            const checkPhone = (rule, value, callback) => {
                if (value) {
                    var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
                    if (reg.test(value) === false) {
                        callback(new Error('电话格式错误'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            }
            return {
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    payers:'',
                    sales:'',
                    company:'',
                    page: 1,
                    limit: 20,
                },
                loadingTitle:'新增Agent',
                dialogVisible:false,
                formData:{
                    company:'',
                    agent_id:'',
                    payers:[],
                    sales:'',
                    email:'',
                    address:'',
                    tel:'',
                    multi_header: 0,
                    company_cn: '',
                    address_cn: '',
                    company_global: '',
                    address_global: ''
                },
                isEdit:false,
                apiKeyDialogVisible: false,
                apiKeyLoading: false,
                apiKeyAgent: {},
                apiKeyStatus: { exists: false, key: null },
                createdApiKey: '',
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                payerList:[],//未被分配二代的payers
                salesList:[],
                payersList:[],//所有payers
                rules: {
                    company: [
                        { required: true, message: '请输入伙伴名称', trigger: 'blur' }
                    ],
                    agent_id:[
                        { required: true, message: '请输入AgentId', trigger: 'blur' }
                    ],
                    payers:[
                        { required: true, message: '请选择Payer', trigger: 'blur' }
                    ],
                    sales:[
                        { required: true, message: '请选择伙伴', trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' }, // 限制必填
                        { required: true, trigger: 'blur', validator: checkEmail }
                    ],
                    tel:[
                        { trigger: 'blur', validator: checkPhone }
                    ]
                },
                curRole:localStorage.getItem('curRole'),
                payerMap: new Map() // 用于存储payer_id到name的映射
            }
        },

        methods:{
            async manageApiKey(agent) {
                this.apiKeyAgent = agent;
                this.apiKeyStatus = { exists: false, key: null };
                this.createdApiKey = '';
                this.apiKeyDialogVisible = true;
                this.apiKeyLoading = true;
                try {
                    const res = await getAgentApiKey(agent.agent_id);
                    if (res.code === 2000) {
                        this.apiKeyStatus = res.data;
                    } else {
                        this.$message.error(res.msg || '获取 API Key 状态失败');
                    }
                } finally {
                    this.apiKeyLoading = false;
                }
            },
            async createApiKey() {
                this.apiKeyLoading = true;
                try {
                    const res = await createAgentApiKey(this.apiKeyAgent.agent_id);
                    if (res.code === 2000) {
                        this.createdApiKey = res.data.api_key;
                        this.apiKeyStatus = {
                            exists: true,
                            agent_id: res.data.agent_id,
                            key: res.data
                        };
                        this.$message.success('API Key 创建成功');
                    } else {
                        this.$message.error(res.msg || 'API Key 创建失败');
                    }
                } finally {
                    this.apiKeyLoading = false;
                }
            },
            async deleteApiKey() {
                try {
                    await this.$confirm('删除后伙伴将立即无法通过该 Key 下载 CUR，确定删除吗？', '删除 API Key', {
                        confirmButtonText: '删除',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    this.apiKeyLoading = true;
                    const res = await deleteAgentApiKey(this.apiKeyAgent.agent_id);
                    if (res.code === 2000) {
                        this.apiKeyStatus = { exists: false, key: null };
                        this.createdApiKey = '';
                        this.$message.success('API Key 已删除');
                    } else {
                        this.$message.error(res.msg || 'API Key 删除失败');
                    }
                } catch (error) {
                    if (error !== 'cancel' && error !== 'close') {
                        this.$message.error('API Key 删除失败');
                    }
                } finally {
                    this.apiKeyLoading = false;
                }
            },
            async copyApiKey() {
                try {
                    await navigator.clipboard.writeText(this.createdApiKey);
                    this.$message.success('API Key 已复制');
                } catch (error) {
                    const input = document.createElement('textarea');
                    input.value = this.createdApiKey;
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                    this.$message.success('API Key 已复制');
                }
            },
            clearApiKeyDialog() {
                this.createdApiKey = '';
                this.apiKeyAgent = {};
                this.apiKeyStatus = { exists: false, key: null };
            },
            //获取列表
            async getData() {
                this.loadingPage = true
                console.log('🔍 开始获取Agent数据，PayersList长度:', this.payersList.length);
                getAgentList(this.formInline).then(res => {
                     this.loadingPage = false
                     if(res.code ==2000) {
                         this.tableData = res.data.data;
                         this.pageparm.page = res.data.page;
                         this.pageparm.limit = res.data.limit;
                         this.pageparm.total = res.data.total;
                         console.log('✅ Agent数据获取成功，共', this.tableData.length, '条记录');
                         console.log('📋 第一条Agent数据:', this.tableData[0]);
                     }
                 })
            },
            // 显示payer名称（后端返回逗号分隔的payer_id字符串）
            getPayerNames(payers) {
                if (!payers) return '';
                const ids = typeof payers === 'string' ? payers.split(',') : (Array.isArray(payers) ? payers : []);
                return ids.map(id => {
                    const name = this.payerMap.get(id.trim());
                    return name || id.trim();
                }).filter(v => v).join(', ');
            },
            getPayList(){
                getUnassignedPayerList().then(res=>{
                    if(res.code==2000){
                        this.payerList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            // 新增保存agent
            submitData(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        // 安全处理数组转字符串
                        this.formData.payers = Array.isArray(this.formData.payers) ? this.formData.payers.join(',') : (this.formData.payers || '');
                        this.formData.email = this.formData.email ? this.formData.email.replaceAll('，',',') : '';
                        // sales保持字符串格式
                        this.formData.sales = this.formData.sales || '';
                        
                        newAgent(this.formData).then(res=>{
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                                // 出错时恢复为数组格式（payers）
                                this.formData.payers = typeof this.formData.payers === 'string' ? this.formData.payers.split(',') : [];
                                // sales保持字符串格式
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            editSubmit(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        // 安全处理数组转字符串
                        this.formData.payers = Array.isArray(this.formData.payers) ? this.formData.payers.join(',') : (this.formData.payers || '');
                        this.formData.email = this.formData.email ? this.formData.email.replaceAll('，',',') : '';
                        // sales保持字符串格式
                        this.formData.sales = this.formData.sales || '';
                        
                        console.log('📤 editSubmit 完整提交数据:', JSON.stringify(this.formData));
                        
                        editAgent(this.formData).then(res=>{
                            console.log('📥 editAgent 响应:', res.code, res.msg);
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                                // 出错时恢复为数组格式（payers）
                                this.formData.payers = typeof this.formData.payers === 'string' ? this.formData.payers.split(',') : [];
                                // sales保持字符串格式
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            add(){
                this.cancel();
                this.dialogVisible=true;
                this.isEdit=false;
                this.loadingTitle="新增Agent"
                if(this.curRole=='sales'){
                    this.formData.sales=localStorage.getItem('account')
                }
            },
            // 编辑agent账号
            edit(obj){
                console.log('📋 edit obj multi_header:', obj.multi_header, 'company_cn:', obj.company_cn);
                this.formData=JSON.parse(JSON.stringify(obj));
                
                // 处理 payers 字段：后端返回逗号分隔的payer_id字符串，转为数组
                if (typeof this.formData.payers === 'string') {
                    this.formData.payers = this.formData.payers ? this.formData.payers.split(',').map(s => s.trim()).filter(s => s) : [];
                } else if (Array.isArray(this.formData.payers)) {
                    // 兼容：如果已经是数组，保持不变
                    this.formData.payers = this.formData.payers.filter(s => s);
                } else {
                    this.formData.payers = [];
                }
                
                // 确保 multi_header 是数字类型
                this.formData.multi_header = parseInt(this.formData.multi_header) || 0;
                
                // 处理 sales 字段：单选，保持字符串格式
                if (typeof this.formData.sales === 'string') {
                    this.formData.sales = this.formData.sales || '';
                } else {
                    this.formData.sales = '';
                }
                
                this.dialogVisible=true;
                this.isEdit=true;
                this.loadingTitle="编辑Agent";
                
                // 重新获取未分配的payer列表，完成后补充当前agent已分配的payers
                getUnassignedPayerList().then(res => {
                    if (res.code == 2000) {
                        this.payerList = res.data.data;
                        // 确保当前agent已分配的payers能在选择框中显示
                        if (Array.isArray(this.formData.payers)) {
                            this.formData.payers.forEach(payerId => {
                                const payer = this.payersList.find(p => p.payer_id === payerId);
                                if (payer && !this.hasEle(payerId)) {
                                    this.payerList.unshift(payer);
                                }
                            });
                        }
                    }
                });
            },
            hasEle(id){
                var num=0;
                this.payerList.forEach(el=>{
                    if(el.payer_id==id){
                        num++;
                    }
                })
                if(num>0){
                    return true
                }else{
                    return false
                }
            },
            // 删除agent账号 
            remove(id){
                this.$confirm('确定删除吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    deleterAgent({id:id}).then(res=>{
                        if(res.code==2000){
                            this.$message.success(res.msg);
                            this.dialogVisible=false;
                            this.getData();
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }).catch(err=>{})
            },
            cancel(){
                this.formData={
                    company:'',
                    agent_id:'',
                    payers:[],
                    sales:'',
                    email:'',
                    address:'',
                    tel:'',
                    multi_header: 0,
                    company_cn: '',
                    address_cn: '',
                    company_global: '',
                    address_global: ''
                };
                this.getPayList();
                this.isEdit=false;
                this.dialogVisible=false;
            },
            reset() {
                this.formInline = {
                    payers:'',
                    sales:'',
                    company:'',
                    page:1,
                    limit: 20
                }
                this.pageparm={
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getData()
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                tabSelectHeight = this.isFull?tabSelectHeight - 110:tabSelectHeight
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
            async permissionData(){
                if(this.curRole=='admin'){
                    this.getSaleList();
                    await this.getPayersList();
                }else{
                    await this.getPayersList();
                }
            },
            // 获取销售列表
            getSaleList(){
                getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList = res.data.data;
                    }else{
                        this.$message.error('获取销售列表失败！');
                    }
                })
            },
            // 获取payer列表
            async getPayersList(){
                return new Promise((resolve, reject) => {
                    getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                        if(res.code==2000){
                            this.payersList = res.data.data;
                            // 建立payer_id到name的映射
                            this.payerMap.clear();
                            this.payersList.forEach(payer => {
                                this.payerMap.set(payer.payer_id, payer.name);
                            });
                            console.log('🔍 PayersList加载完成，共', this.payersList.length, '个payers');
                            // 强制更新表格显示
                            this.$nextTick(() => {
                                this.$forceUpdate();
                            });
                            resolve(res);
                        }else{
                            this.$message.error('获取Payer列表失败！');
                            reject(res);
                        }
                    }).catch(error => {
                        this.$message.error('获取Payer列表失败！');
                        reject(error);
                    });
                });
            }, 
        },
        async created() {
            // 先加载基础数据，再加载列表数据
            await this.permissionData();
            this.getPayList();
            
            if(this.curRole=='sales'){
                this.formData.sales=localStorage.getItem('account');
                this.formInline.sales=localStorage.getItem('account');
            }else{
                this.formData.sales='';
            }
            
            // 确保payers数据加载完成后再获取agent数据
            this.getData();
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>

<style scoped>
.api-key-result {
    display: grid;
    gap: 12px;
    margin-top: 16px;
}

.action-buttons {
    display: flex;
    justify-content: center;
    gap: 6px;
}
</style>


